import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Ga4MetricsComponent } from './ga4-metrics.component';
import { Ga4TableComponent } from './ga4-table/ga4-table.component';
import { Ga4MetricsService } from './ga4-metrics.service';
import { DateRangeSelectorModule } from '../date-range-selector';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { VaGoalTableModule } from '@vendasta/uikit';
import { LoadingStateCardComponent } from '../loading-state-card/loading-state-card.component';
import { MatButtonModule } from '@angular/material/button';
import { MetricsCardComponent } from '../metrics/metrics-card/metrics-card.component';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    TranslateModule,
    FormsModule,
    MatIconModule,
    MatSlideToggleModule,
    DateRangeSelectorModule,
    NgxChartsModule,
    VaGoalTableModule,
    LoadingStateCardComponent,
    MatButtonModule,
    MetricsCardComponent,
  ],
  declarations: [Ga4MetricsComponent, Ga4TableComponent],
  exports: [Ga4MetricsComponent],
  providers: [Ga4MetricsService],
})
export class Ga4MetricsModule {}
